import React from 'react'

const Partners = () => {
  return (
    <div style={{marginTop:"80px"}}>Partners</div>
  )
}

export default Partners